import { useCallback, useEffect } from "react";

import { useCaseListContext } from "../../context/CaseListContext";

export const useCaseFilters = () => {
  const {
    filter,
    setFilter,
    filters,
    setFilters,
    filterClicked,
    from,
    to,
    setPage,
  } = useCaseListContext();

  // Handle filter submission when filter modal closes
  useEffect(() => {
    if (
      filter?.type === "date" &&
      (!filterClicked || (filter?.value?.from && filter?.value?.to))
    ) {
      if (
        filter?.value?.to?.substring(0, 1) !== "0" &&
        filter?.value?.from?.substring(0, 1) !== "0"
      ) {
        if (filter?.value?.from || filter?.value?.to) {
          setFilters([
            ...filters,
            {
              type: filter.type,
              key: filter.key,
              value: `${
                filter.value.from ? filter.value.from : filter.value.to
              }-${filter.value.to ? filter.value.to : filter.value.from}`,
            },
          ]);
          setFilter({ type: null, value: null });
        }
      }
    } else if (filter?.type === "select") {
      if (filter?.value) {
        setFilters([
          ...filters,
          { type: filter.type, key: filter.key, value: filter.value },
        ]);
        setFilter({ type: null, value: null });
      }
    }
  }, [filter, filterClicked]);

  // Update from/to when filter modal closes
  useEffect(() => {
    if (!filterClicked) {
      setFilter({
        value: {
          from: from,
          to: to,
        },
      });
    }
  }, [filterClicked]);

  const handleRemoveFilter = useCallback(
    (index: number) => {
      if (filters?.length === 1) {
        setFilters([]);
      } else {
        setFilters(filters.filter((_, itemIndex) => itemIndex !== index));
      }
      setPage(1);
    },
    [filters, setFilters, setPage],
  );

  return { handleRemoveFilter };
};
